'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

var _ProjectsListHeader = require('components/Projects/ProjectsListHeader/ProjectsListHeader');

var _ProjectsListHeader2 = _interopRequireDefault(_ProjectsListHeader);

var _ProjectsListItem = require('components/Projects/ProjectsListItem/ProjectsListItem');

var _ProjectsListItem2 = _interopRequireDefault(_ProjectsListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectList = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProjectList, _PureComponent);

  function ProjectList() {
    (0, _classCallCheck3.default)(this, ProjectList);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectList.__proto__ || (0, _getPrototypeOf2.default)(ProjectList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          projects = _props.projects,
          showTypeColumn = _props.showTypeColumn,
          showActionsColumn = _props.showActionsColumn,
          deleteLoaders = _props.deleteLoaders,
          activeOrder = _props.activeOrder,
          order = _props.order,
          userPermissions = _props.userPermissions;
      var _props2 = this.props,
          onDelete = _props2.onDelete,
          onCreateSubproject = _props2.onCreateSubproject,
          onEdit = _props2.onEdit,
          onReorder = _props2.onReorder,
          onClick = _props2.onClick;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.List,
          null,
          _react2.default.createElement(_ProjectsListHeader2.default, {
            activeOrder: activeOrder,
            order: order,
            onReorder: onReorder,
            showTypeColumn: showTypeColumn,
            showActionsColumn: showActionsColumn
          }),
          projects.map(function (project) {
            return _react2.default.createElement(_ProjectsListItem2.default, {
              key: project.id,
              project: project,
              onClick: onClick,
              onDelete: onDelete,
              onCreateSubproject: onCreateSubproject,
              onEdit: onEdit,
              showTypeColumn: showTypeColumn,
              showActionsColumn: showActionsColumn,
              deleteLoaders: deleteLoaders,
              userPermissions: userPermissions
            });
          })
        ),
        _react2.default.createElement(_components.Loader, { show: loading, alignCenter: true })
      );
    }
  }]);
  return ProjectList;
}(_react.PureComponent), _class.propTypes = {
  activeOrder: _propTypes2.default.string,
  deleteLoaders: _propTypes2.default.object,
  loading: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onCreateSubproject: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  onReorder: _propTypes2.default.func,
  order: _propTypes2.default.object,
  projects: _propTypes2.default.array.isRequired,
  showActionsColumn: _propTypes2.default.bool,
  showTypeColumn: _propTypes2.default.bool,
  userPermissions: _propTypes2.default.object
}, _class.defaultProps = {
  onCreateSubproject: _noop3.default,
  onDelete: _noop3.default,
  onEdit: _noop3.default,
  onReorder: _noop3.default,
  projects: [],
  loading: false,
  showActionsColumn: false,
  showTypeColumn: false,
  userPermissions: {}
}, _temp);
exports.default = ProjectList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/ProjectsList/ProjectsList.js
// module id = 834
// module chunks = 1